/**
 * Constants for MoodBoard functionality
 */

// Pagination
export const MOODBOARD_PAGE_SIZE = 24; // Number of moodboard items to load per page (larger first load for <50 boards)
